<template>
    <span class="text-primary">
        <i
            class="fa fa-download fa-lg icon-button"
            title="Download"
            @click.stop="downloadAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamentoAnexo: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    methods: {
        downloadAnexo() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .downloadPagamentoAnexo(this.pagamentoAnexo.pagamentoAnexoId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                this.pagamentoAnexo.nomeArquivoOriginal
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
